import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingComponent = ({ className, style }) => {
  const defaultStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    ...style, // Merge with any additional styles passed as props
  };

  return (
    <div className={className} style={defaultStyle}>
      <Spinner animation="border" variant="warning" />
    </div>
  );
};

export default LoadingComponent;
